import { useState, useEffect } from "react";

import classnames from "classnames";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { useTranslation } from "react-i18next";

function ChampionsRoadPage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  const params = useParams();
  const friendUid = params.friendUid;

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [userChampionPoints, setUserChampionPoints] = useState();
  const [userChampionTier, setUserChampionTier] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "users"),
        where("uid", "==", friendUid ? friendUid : user?.uid)
      );
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0].data();
      const championPoints = data.championPoints;
      setUserChampionPoints(championPoints);

      if (championPoints === 0) {
        setUserChampionTier("TIER 0");
      } else if (championPoints >= 1 && championPoints <= 99) {
        setUserChampionTier("TIER 1");
      } else if (championPoints >= 100 && championPoints <= 199) {
        setUserChampionTier("TIER 2");
      } else if (championPoints >= 200 && championPoints <= 299) {
        setUserChampionTier("TIER 3");
      } else if (championPoints >= 300 && championPoints <= 399) {
        setUserChampionTier("TIER 4");
      } else if (championPoints >= 400 && championPoints <= 499) {
        setUserChampionTier("TIER 5");
      } else if (championPoints >= 500 && championPoints <= 599) {
        setUserChampionTier("TIER 6");
      } else if (championPoints >= 600 && championPoints <= 699) {
        setUserChampionTier("TIER 7");
      } else if (championPoints >= 700 && championPoints <= 799) {
        setUserChampionTier("TIER 8");
      } else if (championPoints >= 800 && championPoints <= 899) {
        setUserChampionTier("TIER 9");
      } else if (championPoints >= 900) {
        setUserChampionTier("TIER 10");
      }

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  // eslint-disable-next-line
  const [tierList, setTierList] = useState([
    {
      rank: "TIER 1",
      name: "ROOKIE",
      minChampionPoints: 1,
      maxChampionPoints: 99,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2F01-bronze%201.png?alt=media&token=1c3a8a08-d19c-452f-9f38-1027b0ba7cbe",
    },
    {
      rank: "TIER 2",
      name: "APPRENTICE",
      minChampionPoints: 100,
      maxChampionPoints: 199,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2F02-bronze%202.png?alt=media&token=1f829de8-96e8-498c-8131-e39530754025",
    },
    {
      rank: "TIER 3",
      name: "SEMI PRO",
      minChampionPoints: 200,
      maxChampionPoints: 299,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2F03-bronze%203.png?alt=media&token=8a9eed5e-17a8-40bd-a8a6-b2e7403de69a",
    },
    {
      rank: "TIER 4",
      name: "FULL PRO",
      minChampionPoints: 300,
      maxChampionPoints: 399,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2F04-silver%201.png?alt=media&token=0d86e2d8-cd28-4d12-bba7-3cd3b1a6ad71",
    },
    {
      rank: "TIER 5",
      name: "VETERAN",
      minChampionPoints: 400,
      maxChampionPoints: 499,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2F06-silver%202.png?alt=media&token=3f757feb-42eb-4360-b2d3-f2564e052d23",
    },
    {
      rank: "TIER 6",
      name: "EXPERT",
      minChampionPoints: 500,
      maxChampionPoints: 599,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2F06-silver%203.png?alt=media&token=6d30228c-285a-41fa-b2a7-71e46c7b6284",
    },
    {
      rank: "TIER 7",
      name: "ELITE",
      minChampionPoints: 600,
      maxChampionPoints: 699,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2F07-gold%201.png?alt=media&token=524c637e-c78a-4a0f-bcb9-4bc83f893aa2",
    },
    {
      rank: "TIER 8",
      name: "MASTER",
      minChampionPoints: 700,
      maxChampionPoints: 799,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2F08-gold%202.png?alt=media&token=91722de9-879b-4417-9449-b47978b67f28",
    },
    {
      rank: "TIER 9",
      name: "GRAND MASTER",
      minChampionPoints: 800,
      maxChampionPoints: 899,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2F09-gold%203.png?alt=media&token=ef6315be-826f-403c-ba26-011a93ac52f7",
    },
    {
      rank: "TIER 10",
      name: "WORLD CHAMPION",
      minChampionPoints: 900,
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FchampionsRoadIcons%2FPlatinum.png?alt=media&token=a6efd19e-e13d-4b73-b01e-d708d438f13e",
    },
  ]);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="championsRoadPage" className="page">
      <h1 style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: 8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div>
            CHAMPIONS <br className="hideOnDesktop" />
            ROAD
          </div>
          <span>{userChampionTier}</span>
        </div>
      </h1>
      <div>
        {tierList?.map((tier) => {
          return (
            <div
              className={classnames("championsRoadTierContainer", {
                locked: userChampionPoints < tier.minChampionPoints,
              })}
            >
              <img alt="achievementImage" src={tier.image} />
              <div
                className="championsRoadProgressBarSection"
                style={{
                  borderLeftColor:
                    userChampionPoints > tier.minChampionPoints
                      ? "#FABB00"
                      : "#FABB0025",
                }}
              >
                {userChampionPoints > tier.minChampionPoints &&
                  userChampionPoints < tier.maxChampionPoints && (
                    <p>
                      {userChampionPoints} <br className="hideOnDesktop" />
                      CPs
                    </p>
                  )}
              </div>
              <div>
                <p className="tierName" style={{ paddingTop: "0.5rem" }}>
                  {tier.rank} - {tier.name}
                </p>
                <p style={{ paddingBottom: "0.5rem" }}>
                  {t("from")} {tier.minChampionPoints} {t("to").toLowerCase()}{" "}
                  {tier.maxChampionPoints} Champion Points
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ChampionsRoadPage;
